// src/locales/en/employeeCommission.js
export const employeeCommission = {
  // Page titles
  commissionConfigTitle: 'Commission Configuration',
  commissionConfigSubtitle: 'Configure how employee commissions are calculated',
  commissionReportTitle: 'Employee Commission Report',
  commissionReportSubtitle: 'View commission summaries for commissioned employees',

  // View toggle
  userView: 'User View',
  productView: 'Product View',
  userViewNote: 'Commission is only calculated for employees added in this view.',

  // Table headers - User view
  userId: 'ID',
  userName: 'Name',
  employeeNumber: 'Employee #',
  confirmCommission: 'Confirm Commission',
  createCommission: 'Create Commission',
  calculationBasis: 'Calculation Basis',
  actions: 'Actions',

  // Table headers - Product view
  productId: 'Product ID',
  productName: 'Product',
  sku: 'SKU',

  // Calculation basis options
  orderCount: 'Per Order',
  orderQuantity: 'Per Item Qty',
  orderValue: '% of Order Value',
  orderCountDescription: 'Fixed amount per order',
  orderQuantityDescription: 'Fixed amount per order item quantity',
  orderValueDescription: 'Percentage of order grand total',

  // Buttons
  addEmployee: 'Add Employee',
  addProduct: 'Add Product',
  editEmployee: 'Edit',
  editProduct: 'Edit',
  deleteConfig: 'Delete',
  bulkAdd: 'Bulk Add',
  bulkEdit: 'Bulk Edit',
  viewProductCommissions: 'Product Commissions',
  viewEmployeeCommissions: 'Employee Commissions',
  export: 'Export Excel',
  save: 'Save',
  saving: 'Saving...',
  cancel: 'Cancel',
  close: 'Close',
  add: 'Add',

  // Modals - Employee Level Single
  addEmployeeConfig: 'Add Employee Commission',
  editEmployeeConfig: 'Edit Employee Commission',
  selectEmployee: 'Select Employee',
  searchEmployee: 'Search employees...',
  confirmCommissionLabel: 'Confirm Commission',
  createCommissionLabel: 'Create Commission',
  calculationBasisLabel: 'Calculation Basis',
  confirmCommissionHelp: 'Commission for orders confirmed by this employee',
  createCommissionHelp: 'Commission for orders created by this employee',
  startDateLabel: 'Start Date',
  startDateHelp: 'Only orders created on or after this date will count towards commission. Leave blank to include all orders.',

  // Modals - Employee Level Bulk
  bulkEmployeeConfig: 'Bulk Employee Commission',
  bulkAddDescription: 'Add commission configuration for multiple employees at once.',
  bulkEditDescription: 'Edit commission for selected employees.',
  selectEmployees: 'Select Employees',
  applyToSelected: 'Apply to Selected',

  // Modals - Product Level Single
  addProductConfig: 'Add Product Commission',
  editProductConfig: 'Edit Product Commission',
  selectProduct: 'Select Product',
  searchProduct: 'Search products...',

  // Modals - Product Level Bulk
  bulkProductConfig: 'Bulk Product Commission',

  // Modals - Employee-Product Level (from user view)
  employeeProductTitle: "{{name}}'s Product Commissions",
  employeeProductSubtitle: 'Override commission for specific products for this employee.',
  noEmployeeProductConfigs: 'No product-specific overrides configured.',
  addProductOverride: 'Add Product Override',
  searchProducts: 'Search products to add...',

  // Modals - Product-Employee Level (from product view)
  productEmployeeTitle: 'Employee Overrides for {{name}}',
  productEmployeeSubtitle: 'Set specific commission for employees for this product.',
  noProductEmployeeConfigs: 'No employee-specific overrides configured.',
  addEmployeeOverride: 'Add Employee Override',

  // Product view access warning
  productViewLockedTitle: 'Product View Requires Employee Setup',
  productViewLockedMessage:
    'You need to add at least one commissioned employee in the User View before configuring product-level commissions.',

  // Report page
  selectDateRange: 'Select Date Range',
  lastMonth: 'Last Month',
  thisMonth: 'This Month',
  customDateRange: 'Custom Date Range',
  dateFrom: 'Date From',
  dateTo: 'Date To',
  generateReport: 'Generate Report',
  generating: 'Generating...',

  // Report table columns
  reportUserName: 'Employee',
  reportEmployeeNumber: 'Emp #',
  reportConfirmedOrderValue: 'Confirmed Order Value',
  reportConfirmedOrderCount: 'Confirmed Orders',
  reportConfirmedOrderQty: 'Confirmed Item Qty',
  reportConfirmCommissionRate: 'Confirm Rate',
  reportCreateCommissionRate: 'Create Rate',
  reportTotalConfirmCommission: 'Total Confirm Commission',
  reportTotalCreateCommission: 'Total Create Commission',
  reportTotalCommission: 'Total Commission',
  downloadDetail: 'Download Detail',

  // Detail Excel columns
  detailOrderNumber: 'Order Number',
  detailAirwaybill: 'Airwaybill',
  detailCourier: 'Courier',
  detailItems: 'Items',
  detailCreated: 'Created',
  detailConfirmed: 'Confirmed',
  detailGrandTotal: 'Grand Total',
  detailTotalQty: 'Total Qty',
  detailConfirmCommissionRate: 'Confirm Rate',
  detailCreateCommissionRate: 'Create Rate',
  detailConfirmCommission: 'Confirm Commission',
  detailCreateCommission: 'Create Commission',

  // Empty states
  noEmployeeConfigs: 'No commissioned employees configured',
  noEmployeeConfigsDesc: 'Add employees to start configuring commissions.',
  noProductConfigs: 'No product commissions configured',
  noProductConfigsDesc: 'Add products to configure product-level commission overrides.',
  noReportData: 'No commission data found',
  noReportDataDesc: 'No delivered orders found for the selected date range.',

  // Validation
  selectEmployeeRequired: 'Please select an employee',
  selectProductRequired: 'Please select a product',
  calculationBasisRequired: 'Please select a calculation basis',
  confirmCommissionRequired: 'Confirm commission is required',
  createCommissionRequired: 'Create commission is required',
  dateFromRequired: 'Start date is required',
  dateToRequired: 'End date is required',
  dateRangeInvalid: 'End date must be after start date',

  // Success / Error messages
  configSaved: 'Commission configuration saved',
  configDeleted: 'Commission configuration deleted',
  bulkConfigSaved: 'Commission configurations saved',
  configSaveFailed: 'Failed to save commission configuration',
  configDeleteFailed: 'Failed to delete commission configuration',
  reportGenerateFailed: 'Failed to generate commission report',
  detailExportFailed: 'Failed to export detail report',
  confirmDelete: 'Are you sure you want to delete this commission configuration?',

  // Month names for date range picker
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',

  // Loading
  loading: 'Loading...',
  loadingReport: 'Generating report...',
};